import { Injectable } from '@angular/core';

import { EnvironmentActions } from '@app/core/actions';
import { DomainService } from '@app/core/services/domain.service';
import * as fromRoot from '@app/reducers';
import { setConfigHosts, setRegion } from '@app/shared/helpers/config';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadServicesGuard {

  constructor(
    private store$: Store<fromRoot.State>,
    private readonly domainService: DomainService,
  ) { }

  canActivate(): Observable<boolean> {
    return this.loadServices().pipe(map((servicesLoaded: boolean) => {
      return servicesLoaded;
    }));
  }

  loadServices(): Observable<boolean> {
    const servicesLoaded$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      select(fromRoot.selectServices),
      distinctUntilChanged(),
      takeUntil(servicesLoaded$),
    ).subscribe((res: any) => {
      if (res?.countryCode) {
        setConfigHosts(res.services);
        setRegion(res.region);
        servicesLoaded$.next(true);
      } else {
        const key = 'region';
        const url = this.domainService.detectDomainUrl();
        const params = new URLSearchParams(new URL(url).search);
        const region = params.get(key);
        if (region) {
          this.store$.dispatch(EnvironmentActions.loadServices({ region }));
        } else {
          this.store$.dispatch(EnvironmentActions.loadServices({}));
        }
      }
    });
    return servicesLoaded$.asObservable();
  }
}
